const TAB_STATS = 'stats'
const TAB_EVENTS = 'events'

function read(query = {}) {
  if (Object.prototype.hasOwnProperty.call(query, 'events')) return TAB_EVENTS
  if (Object.prototype.hasOwnProperty.call(query, 'stats')) return TAB_STATS
  return TAB_STATS
}

function hasTab(query = {}) {
  return Object.prototype.hasOwnProperty.call(query, 'events') || Object.prototype.hasOwnProperty.call(query, 'stats')
}

function withTab(query = {}, active = TAB_STATS) {
  const next = { ...query }
  delete next.stats
  delete next.events
  if (active === TAB_EVENTS) next.events = ''
  else next.stats = ''
  return next
}

class TrackingViewTabUtility {
  TAB_STATS = TAB_STATS
  TAB_EVENTS = TAB_EVENTS

  read(query) {
    return read(query)
  }

  hasTab(query) {
    return hasTab(query)
  }

  withTab(query, active) {
    return withTab(query, active)
  }
}

export default new TrackingViewTabUtility()
